import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import MainApp from './core/containers/Main';
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import store, { persistor } from 'Redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import packageJson from '../package.json';
import { LogManagerConsole } from 'Core/logManager';
import { initializeDataDog } from 'Core/datadog';
import { FeatureToggleProvider } from 'Components/FeatureToggle';
import { ErrorBoundary } from 'Components';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'Core/queryClient';

// Initialize DataDog before React starts
initializeDataDog();

const App = () => {

	LogManagerConsole(`Version. ${packageJson.version}`);

	return (
		<>
			{/* Load global frame for legacy integration*/}
			<ErrorBoundary>
				<QueryClientProvider client={queryClient}>
					<Provider store={store}>
						<PersistGate loading={null} persistor={persistor}>
							<FeatureToggleProvider>
								<BrowserRouter>
									<Routes>
										<Route path="*" element={<MainApp />} />
									</Routes>
								</BrowserRouter>
							</FeatureToggleProvider>
						</PersistGate>
					</Provider>
				</QueryClientProvider>
			</ErrorBoundary>
		</>
	);
};



ReactDOM.createRoot(document.getElementById('root')).render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
